import {
  UPLOAD_ATTACHMENT_SUCCESS,
  DELETE_ATTACHMENT_SUCCESS,
  UPDATE_OUTLINE,
  UPDATE_OUTLINE_SUCCESS,
  CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR,
  GENERATE_OUTLINE_SUCCESS,
  GENERATE_OUTLINE,
  GENERATE_OUTLINE_ERROR,
  CLEAR_OUTLINE,
  SUGGEST_GOAL,
  SUGGEST_GOAL_SUCCESS,
  SUGGEST_GOAL_ERROR,
  SUGGEST_SECTION_TITLE,
  SUGGEST_SECTION_TITLE_SUCCESS,
  SUGGEST_SECTION_TITLE_ERROR,
  SUGGEST_PAGE_TITLE,
  SUGGEST_PAGE_TITLE_SUCCESS,
  SUGGEST_PAGE_TITLE_ERROR,
  SUGGEST_PAGE_OUTLINE,
  SUGGEST_PAGE_OUTLINE_SUCCESS,
  SUGGEST_PAGE_OUTLINE_ERROR,
  SET_COURSE_ATTACHMENTS,
} from './type'

// eslint-disable-next-line import/no-anonymous-default-export
export default function (
  state = {
    attachments: [],
    errorOccurred: {
      error: false,
      message: '',
    },
    outline: null,
    outlineLoading: false,
    outlineError: null,
    topic: '', // Store the course topic
    suggestionLoading: false,
  },
  action,
) {
  const { payload, type } = action
  switch (type) {
    case GENERATE_OUTLINE:
      return {
        ...state,
        outlineLoading: true,
        outlineError: null,
        topic: payload?.req?.topic || '', // Store the topic from the request
        languageCode: payload?.req?.languageCode || '', // Store the topic from the request
      }
    case GENERATE_OUTLINE_SUCCESS:
      return {
        ...state,
        outline: payload,
        outlineLoading: false,
        outlineError: null,
      }
    case GENERATE_OUTLINE_ERROR:
      return {
        ...state,
        outlineLoading: false,
        outlineError: payload || 'Failed to generate outline',
      }
    case CLEAR_OUTLINE:
      return {
        ...state,
        attachments: [],
        errorOccurred: {
          error: false,
          message: '',
        },
        outline: null,
        outlineLoading: false,
        outlineError: null,
        topic: '',
        languageCode: '',
        suggestionLoading: false,
      }
    case UPDATE_OUTLINE:
      return {
        ...state,
        outline: {
          ...state.outline,
          response: {
            ...state.outline.response,
            ...payload.req,
          },
        },
      }
    case UPDATE_OUTLINE_SUCCESS:
      return state
    case UPLOAD_ATTACHMENT_SUCCESS:
      const fileName = payload?.fileName
      const fileId = payload?.response?.attachment_id
      if (fileName == undefined && fileId == undefined) {
        return {
          ...state,
          attachments: [],
        }
      }
      return {
        ...state,
        outlineLoading: false,
        attachments: [
          ...state.attachments,
          {
            file_name: fileName,
            attachment_id: fileId,
            succeeded: false,
            file_url: null,
            ...payload.response,
          },
        ],
      }
    case CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR:
      return {
        ...state,
        attachments: state.attachments.map(attachment => {
          if (attachment.attachment_id === payload.response.attachment_id) {
            return {
              ...attachment,
              ...payload.response,
              file_name: payload.response.file_name || attachment.file_name,
              file_url: payload.response.file_url || attachment.file_url,
              succeeded: payload.response.succeeded,
              upload_status: payload.response.upload_status,
              error_details: payload.response.error_details,
            }
          }
          return attachment
        }),
      }

    case DELETE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        outlineLoading: false,
        attachments: state.attachments.filter(
          attachment => attachment.attachment_id !== payload.response,
        ),
      }
    case SUGGEST_GOAL:
    case SUGGEST_SECTION_TITLE:
    case SUGGEST_PAGE_TITLE:
    case SUGGEST_PAGE_OUTLINE:
      return {
        ...state,
        suggestionLoading: true,
      }
    case SUGGEST_GOAL_SUCCESS:
      return {
        ...state,
        suggestionLoading: false,
      }
    case SUGGEST_GOAL_ERROR:
      return {
        ...state,
        suggestionLoading: false,
      }
    case SUGGEST_SECTION_TITLE_SUCCESS:
      return {
        ...state,
        suggestionLoading: false,
      }
    case SUGGEST_SECTION_TITLE_ERROR:
      return {
        ...state,
        suggestionLoading: false,
      }
    case SUGGEST_PAGE_TITLE_SUCCESS:
      return {
        ...state,
        suggestionLoading: false,
      }
    case SUGGEST_PAGE_TITLE_ERROR:
      return {
        ...state,
        suggestionLoading: false,
      }
    case SUGGEST_PAGE_OUTLINE_SUCCESS:
      return {
        ...state,
        suggestionLoading: false,
      }
    case SUGGEST_PAGE_OUTLINE_ERROR:
      return {
        ...state,
        suggestionLoading: false,
      }
    case SET_COURSE_ATTACHMENTS:
      return {
        ...state,
        attachments: payload.attachments || [],
      }
    default:
      return state
  }
}
